import React, { Component } from 'react'
import MyDateTime from './MyDateTime.js'
import Dropdown from './dropdown.js'
// import axios from 'axios'
import moment from 'moment'
import allZipCodes from './lists.js';

require('moment/locale/de');

class ContactForm extends Component {
    constructor(props) {
        super(props);

        this.mailtoref = React.createRef();

        this.state = {
            emailError: false,
            nameError: false,
            occasionError: false,
            dateError: false,
            textError: false,
            locationError: false,
            whyUsError: false,
            sendTimeout: 0,
            contactReturnMessage: "",
            overallError: false,
            occasionInput: "",
            emailInput: "",
            nameInput: "",
            dateInput: "",
            timeInput: "",
            textInput: "",
            locationInput: "",
            whyUsInput: "",
        };
    }

    countdownSendTimeout() {
        let timeout = this.state.sendTimeout - 1;
        this.setState({
            sendTimeout: timeout,
        });
        if (timeout > 0) {
            setTimeout(() => this.countdownSendTimeout(), 1000);
        }
    }

    validateEmail(email) {
        var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    handleSubmitContact(mailtoref) {
        let emailError = !this.validateEmail(this.state.emailInput.trim()),
            nameError = this.state.nameInput.trim() === "",
            occasionError = this.state.occasionInput.trim() === "",
            dateError = this.state.dateInput.trim() === "",
            timeError = this.state.timeInput.trim() === "",
            textError = this.state.textInput.trim() === "",
            whyUsError = this.state.whyUsInput.trim() === "",
            locationError = this.state.locationInput.trim() === "",
            contactReturnMessage = "",
            overallError = true;

        if (!emailError && !nameError && !occasionError && !dateError && !textError && !locationError && !whyUsError && !timeError) {
            contactReturnMessage = "Bitte öffne die Nachricht über dein Email-Programm und schicke sie dort ab. Alternativ schreib uns bitte direkt an info@pluspunkt-musik.de";
            overallError = false;

            mailtoref.current.click()
        }
        else {
            contactReturnMessage = "Nicht alle Angaben sind korrekt. Bitte überprüfe die markierten Felder.";
            overallError = true;
        }

        this.setState({
            emailError: emailError,
            nameError: nameError,
            occasionError: occasionError,
            dateError: dateError,
            timeError: timeError,
            textError: textError,
            locationError: locationError,
            whyUsError: whyUsError,
            contactReturnMessage: contactReturnMessage,
            overallError: overallError,
        });
    }

    render() {
        return (
            <div>
                {/* <h1 ref="h1Kontakt" className="underline"><div className="anchor" id="kontakt"></div>Kontakt</h1> */}
                <form className="Kontakt-form" method="POST" action="emailHandler.php" id="emailForm">
                    <div className="Kontakt-form-label">Email</div>
                    <input className={"Kontakt-form-input" + (this.state.emailError ? " error" : "")} type="text" onChange={(e) => this.setState({ emailInput: e.target.value })} />
                    <div className="Kontakt-form-label">Name</div>
                    <input className={"Kontakt-form-input" + (this.state.nameError ? " error" : "")} type="text" onChange={(e) => this.setState({ nameInput: e.target.value })} />
                    <div className="Kontakt-form-label">Anlass</div>
                    <input className={"Kontakt-form-input" + (this.state.occasionError ? " error" : "")} type="text" onChange={(e) => this.setState({ occasionInput: e.target.value })} />
                    <div className="Kontakt-form-label">Datum</div>
                    <MyDateTime className={" " + (this.state.dateError ? " error" : "")} timeFormat={false} onChange={(e) => {
                        if (e instanceof moment)
                            this.setState({ dateInput: e.format("DD.MM.YYYY") });
                        else
                            this.setState({ dateInput: e });
                    }
                    } />
                    <div className="Kontakt-form-label">Uhrzeit (von/bis)</div>
                    <input className={"Kontakt-form-input" + (this.state.timeError ? " error" : "")} type="text" onChange={(e) => this.setState({ timeInput: e.target.value })} />
                    <div className="Kontakt-form-label">Ort der Veranstaltung</div>
                    <Dropdown elements={allZipCodes} inputType="text" onValueChange={(value) => { this.setState({ locationInput: value }); }} error={this.state.locationError} />
                    <div className="Kontakt-form-label">Woher kennst du uns?</div>
                    <Dropdown elements={['Habe euch live gesehen', 'Von Freunden/Bekannten', 'Google', 'Facebook', 'Eventpeppers', 'Etwas anderes']} onValueChange={(value) => { this.setState({ whyUsInput: value }); }} error={this.state.whyUsError} />
                    <div className="Kontakt-form-label">Nachricht</div>
                    <textarea className={"Kontakt-form-input" + (this.state.textError ? " error" : "")} type="text" value={this.state.textInput} onChange={(e) => this.setState({ textInput: e.target.value })}></textarea>
                    {/* <button type="button" disabled={this.state.sendTimeout > 0 ? true : false} className="Kontakt-form-submit" onClick={() => this.handleSubmitContact()}>Abschicken</button> */}
                    <button type="button" disabled={this.state.sendTimeout > 0 ? true : false} className="Kontakt-form-submit" onClick={() => { this.handleSubmitContact(this.mailtoref) }}>
                        {/* mailto:RECEIPIENT?subject=Auftrittsanfrage%20Pluspunkt%20DATE&body=Name%3A%20NAME%0D%0AEmail%3A%20EMAIL%0D%0AAnlass%3A%20VERANSTALTUNG%0D%0ADatum%3A%20DATE%0D%0AUhrzeit%3A%20TIME%0D%0AOrt%20der%20Veranstaltung%3A%20LOCATION%0D%0AWoher%20kennst%20du%20uns%3F%20BEKANNTDURCH%0D%0A%0D%0ATEXT */}
                        <a target="_blank" ref={this.mailtoref} href={"mailto:info@pluspunkt-musik.de?subject=Auftrittsanfrage%20Pluspunkt%20" + this.state.dateInput.trim() + "&body=Name%3A%20" + this.state.nameInput.trim() + "%0D%0AEmail%3A%20" + this.state.emailInput.trim() + "%0D%0AAnlass%3A%20" + this.state.occasionInput.trim() + "%0D%0ADatum%3A%20" + this.state.dateInput.trim() + "%0D%0AUhrzeit%3A%20" + this.state.timeInput.trim() + "%0D%0AOrt%20der%20Veranstaltung%3A%20" + this.state.locationInput.trim() + "%0D%0AWoher%20kennst%20du%20uns%3F%20" + this.state.whyUsInput.trim() + "%0D%0A%0D%0A" + this.state.textInput.trim().replaceAll('\n', "%0D%0A")}></a>
                        Unverbindlich Anfragen
                    </button>
                </form>
                <div className="Kontakt-return-label">
                    <div className={this.state.overallError ? "texterror" : ""}>
                        {this.state.contactReturnMessage + (this.state.sendTimeout > 0 ? ' - erneut versuchen in ' + this.state.sendTimeout + ' Sekunden. ' : "")}
                    </div>
                </div>
            </div>
        );
    }
}

export default ContactForm;


// WEBPACK FOOTER //
// ./src/contact-form/contact-form.js